module.exports = __webpack_public_path__ + "static/media/manual_colocador.e887da52.pdf";